<div class="flex flex-col gap-3">

	<div class="w-full flex justify-between items-start">
		<div class="cursor-pointer iteminner" (click)="navigate(product)">
			<img src="{{product.customization.finishedProductPreview ? product.customization.finishedProductPreview.product.heroImage : product.customization.fabricProductPreview!.product.heroImage}}"
				 class="rounded-md"
				 alt=""/>
		</div>
		<div class=" w-full flex md:hidden flex-col justify-between items-stretch">
			<div class="inter_info_cont w-full">
				<p class="item_name"
				   [innerHTML]="(product.customization.finishedProductPreview ? product.customization.finishedProductPreview.product.name : product.customization.fabricProductPreview!.product.name)  | truncketHtml:40">
				</p>
				<p class="price">{{ product.currency | uppercase }} {{ product.price | number: '1.0-2' }} | {{ product.quantity }} {{ product.unit }}</p>

				<p *ngIf="product.customization.selectedFabric" class="price">Fabric : {{ product.customization.selectedFabric.product.sku }}</p>

				<p *ngIf="product.customization.selectedSizeOption" class="price">

					{{ product.customization.sizeDisplayName ? product.customization.sizeDisplayName : 'Size:' }}
					{{ product.customization.selectedSizeOption.label }}</p>

				<p *ngIf="product.customization.customSize" class="price">


					{{ prepareCustomSizeLabel(product.customization.customSize) }}</p>

				<p *ngIf="product.customization.selectedFinishList && product.customization.selectedFinishList.length" class="price">
					{{ product.customization.finishDisplayName ? product.customization.finishDisplayName : 'Finish:' }}
					{{ prepareFinishLabel(product.customization.selectedFinishList) }}.</p>
			</div>
		</div>
		<div class="md:max-w-[64%] w-full hidden md:flex flex-col justify-between items-stretch">
			<div class="flex justify-between items-start w-full">
				<div class="inter_info_cont ">
					<p class="item_name"
					   [innerHTML]="(product.customization.finishedProductPreview ? product.customization.finishedProductPreview.product.name : product.customization.fabricProductPreview!.product.name)  | truncketHtml:40">
					</p>
					<p class="price">{{ product.currency | uppercase }} {{ product.price | number: '1.0-2' }} | {{ product.quantity }} {{ product.unit }}</p>

					<p *ngIf="product.customization.selectedFabric" class="price">Fabric : {{ product.customization.selectedFabric.product.sku }}</p>

					<p *ngIf="product.customization.selectedSizeOption" class="price">

						{{ product.customization.sizeDisplayName ? product.customization.sizeDisplayName : 'Size:' }}
						{{ product.customization.selectedSizeOption.label }}</p>

					<p *ngIf="product.customization.customSize" class="price">


						{{ prepareCustomSizeLabel(product.customization.customSize) }}</p>

					<p *ngIf="product.customization.selectedFinishList && product.customization.selectedFinishList.length" class="price">
						{{ product.customization.finishDisplayName ? product.customization.finishDisplayName : 'Finish:' }}
						{{ prepareFinishLabel(product.customization.selectedFinishList) }}.</p>
				</div>

				<button *ngIf="product.orderStatus === 'IN_TRANSIT'"
						class="mt-1.5 max-w-[180px] bg-[#fffcf7] rounded border-2 border-[#8E7862] text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
	transition-colors flex items-center justify-center gap-2 text-xs sm:text-sm"
						type="submit"
						(click)="onAddReview()">
					<span>{{ product.reviewId && product.reviewId != 0 ? 'Edit' : 'Add'}}</span> Review
				</button>
			</div>
			<div *ngIf="product.hasWorkflow" class="w-full">
				<fb-order-item-process-overview *ngIf="!loading"
												[product]="product"
												[orderId]="orderId"
												[orderItemId]="orderItemId"
												(emitMoreUpdatesToggle)="onViewProcessUpdates($event)"
												[workflow]="orderItemWorkflow"></fb-order-item-process-overview>
			</div>
		</div>

	</div>
	<div *ngIf="product.hasWorkflow" class="md:hidden w-full">
		<fb-order-item-process-overview *ngIf="!loading"
										[product]="product"
										[orderId]="orderId"
										[orderItemId]="orderItemId"
										(emitMoreUpdatesToggle)="onViewProcessUpdates($event)"
										[workflow]="orderItemWorkflow"></fb-order-item-process-overview>
	</div>
	<div class="flex justify-center items-center md:hidden w-full bmx-hide-xl bmx-hide-lg bmx-hide-md">
		<button *ngIf="product.orderStatus === 'IN_TRANSIT'"
				class="w-full mt-1.5 max-w-[180px] bg-[#fffcf7] rounded border-2 border-[#8E7862] text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
	transition-colors flex items-center justify-center gap-2 text-xs sm:text-sm"
				type="submit"
				(click)="onAddReview()">
			<span>{{ product.reviewId && product.reviewId != 0 ? 'Edit' : 'Add'}}</span> Review
		</button>
	</div>

</div>
<fb-order-item-process-status *ngIf="showProcess"
							  [id]="orderItemId + '-feedback'"
							  [product]="product"
							  [orderId]="orderId"
							  [workflow]="orderItemWorkflow"></fb-order-item-process-status>

